import React, { useState, useEffect } from 'react'
import { cards, categories } from '../data/cardInfo'
import classNames from 'classnames'
import styled, { css } from 'styled-components'
import { size } from 'lodash'
import img_arrow from '../img/arrow.svg'
import img_turn from '../img/turn.svg'


const Card = ({ front, back, zoomed, zoomSelf}) => {
    const [rotated, setRotated] = useState(false)
    
    const handleClick = () => {
        if (zoomed) {
            setRotated(!rotated)
        } else {
            zoomSelf()
        }
    }

    useEffect(() => {
        if (!zoomed) {
            setRotated(false)
        }
    }, [zoomed])


    return (
        <div onClick={handleClick} className={classNames('training-card', { zoomed }, { rotated } )} >
            
            <img src={require(`../img/${front}`).default} className={classNames('card-front')} />             
           
            <img src={require(`../img/${back}`).default} className={classNames('card-back')} />
            <img src={img_turn} className={classNames('training-card-image', { zoomed })} />
           
        </div>
    )
}

const Train = () => {

    const Wrapper = styled.div`
        display:grid;
        place-items: center;
        min-height: 600px;
        overflow:hidden;
        
    `

    const CategoriesList = styled.div`       
        place-items: center;
        transition: max-height 1s ease-out;
        align-items: center;
        
    `
    const CategoriesHeading = styled.div`
        color: white;
        position:relative;
        margin-top:5px;
        padding-top:25px;
        font-size:20px!important;
        
        margin: 0 0 1% 0;
        height: 50px;
        background: ${props => props.color}  
    `
    
    const HeaderImage = styled.div`
        position:absolute;
        right:20px;
        top:25px;
       
     `   
    const HeaderText = styled.div`
        float:center;
        
    `
    
    const CategoriesCardList = styled.div`
        
        -ms-box-orient: horizontal;
        display: flex;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
        justify-content: center;
        overflow: hidden;
        transition: max-height 0.5s;
        height:100%;
        max-height: 3000px!important;
        
    
    `
    const Header = styled.div`
        font-size: 40px;
    `
    const Text = styled.div`
        font-size: 0.8em;
        margin-bottom:20px;
        padding:20px;
        max-width:40em;
        margin: auto;
    `



    const allCards = cards
    const allCategories = categories
    const [zoomedCard, setZoomedCard] = useState()
    const [selectedCategory, setSelectedCategory] = useState()
   
    const handleCardClick = (index) => {
        selectedCategory === index ? setSelectedCategory(-1) : setSelectedCategory(index)
        setZoomedCard(-1)
    }

    return ( 
        <div> 
            <h1>
                Träna på begrepp
            </h1>
            <Text>
                Här kan du träna på olika begrepp om informationspåverkan. Tryck en gång på ett kort för att förstora, och en gång till för att se baksidan av kortet med ett exempel på begreppet.
            </Text>
            {

                
                             
                                   
                                    <div className={classNames('categories-card-list', 'expanded')} >
                                    {
                                        allCards.map((card, index) => { 
                                            return (
                                                <Card key={index * 2}
                                                    front={card.imgFront}
                                                    back={card.exampleFront}
                                                    zoomed={zoomedCard === index}
                                                    zoomSelf={() => setZoomedCard(index)}
                                                 />)
                                        })
                                    } 
                                    </div>
                                   
                        
                    
                }
        </div>
    )
}

export default Train